"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
const frontend_library_darkhorse_1 = require("@usafacts/frontend-library-darkhorse");
const react_dom_1 = __importDefault(require("react-dom"));
const react_1 = __importDefault(require("react"));
const chart_helpers_1 = require("../../util/chart.helpers");
class MosaicPlot {
  constructor(container) {
    this.container = container;
  }
  async draw(promises, options) {
    const resolvedData = await promises.data;
    const extractedMetrics = resolvedData.map(_ref => {
      let {
        color,
        metric
      } = _ref;
      return {
        ...metric,
        color,
        data: metric.data.map(_ref2 => {
          let {
            key,
            value
          } = _ref2;
          return {
            key: (0, chart_helpers_1.dateFormat)(key, metric.x_type),
            value
          };
        })
      };
    });
    react_dom_1.default.render(react_1.default.createElement(frontend_library_darkhorse_1.MosaicPlot, {
      ...options,
      data: extractedMetrics
    }), this.container.node());
  }
  static drawCanvas() {
    /* no canvas here */
  }
}
exports.default = MosaicPlot;